export type SupportEntry = 'form' | 'mailto' | 'none'

/**
 * Which support entry the user menu offers. The form needs a backend that is
 * wired and has been switched on (`capabilities.supportForm`); the mailto link
 * needs only an address the deployment has named (`capabilities.supportEmail`).
 * With neither there is NOTHING to offer, and the menu hides the entry rather
 * than show a link to an address nobody has vouched for.
 *
 * Fails closed like `useCapability`: only an exact `true` is the form, so an
 * unloaded session or an older API gets the link if there is an address and
 * nothing if there is not.
 */
export function supportEntry(
  supportForm: boolean | null | undefined,
  email?: string | null,
): SupportEntry {
  if (supportForm === true) return 'form'
  return typeof email === 'string' && email.trim() !== '' ? 'mailto' : 'none'
}
